import Flickity from "flickity";

export default class CarouselContent {
  constructor() {
    const $els = document.querySelectorAll('.js-carousel-content');
    $els.forEach(($el) => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;
    this.$carousel = $el.querySelector('.js-carousel-content-carousel');
    this.carousel = new Flickity(this.$carousel, {
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      imagesLoaded: true,
    });
  }
}
